import React from "react";
import { NavigationLinks, Section } from "../../../components";
import { AcionarSeguro } from "../Sections";
import ImageNavigationLinks from "../../../assets/images/residencial/ilustracao-homem-casa.svg";
import HeroSection from "../../../components/Habitacional/HeroSection";
import BannerMobile from "../../../assets/images/backgrounds/Banner_Residencial_Mobile.png";
import BannerDesktop from "../../../assets/images/backgrounds/Banner_Residencial_Desktop.png";


const HomePage = () => {
  return (
    <>
      <HeroSection 
        backgroundImageDesktop={BannerDesktop}
        backgroundImageMobile={BannerMobile}
        primarySubtitle="Seguro"
        mainTitle="Residencial"
      />
      <Section
        as={NavigationLinks}
        sectionName="Comece por aqui"
        sectionTitle="Comece por aqui"
        imgSrc={ImageNavigationLinks}
      />
      <Section as={AcionarSeguro} sectionName="Quer acionar seu seguro?" />
    </>
  );
};

export default HomePage;
